<template lang="html">
  <div class="ui form sixteen wide" :class="{ loading }">
    <div v-if="errors" class="ui error message visible" v-html="errors" />
    <div
      v-if="duplicates && duplicates.length > 0"
      class="ui error message visible"
    >
      {{ duplicates.length }} duplicate deliverable{{
        duplicates.length > 1 ? "s" : ""
      }}
      not added.
    </div>

    <div class="field">
      <label for="" class="label"
        >Deliverable URLs or Names (one per line)</label
      >
      <div class="ui fluid search" ref="deliverables">
        <div class="ui input">
          <textarea
            v-model="urls"
            :class="{ 'file-hover': isFileHovering }"
            class="prompt"
            name="name"
            rows="3"
            cols="80"
            placeholder="Paste your deliverable URLs here and we'll label them automatically. Like magic!"
            @keydown.meta.enter.prevent="addUrls"
            @drop.prevent="handleFileDrop"
            @dragover.prevent="handleDragOver"
            @dragleave.prevent="handleDragLeave"
          />
        </div>
      </div>
    </div>
    <button class="ui button primary" type="submit" @click="addUrls">
      Add
    </button>
  </div>
</template>

<script>
const $ = window.jQuery;

export default {
  props: {
    endpoint: String,
  },
  data() {
    return {
      errors: null,
      duplicates: null,
      loading: false,
      urls: "",
      instagramReelsData: null,
      isFileHovering: false,
    };
  },
  watch: {
    urls(newVal) {
      this.alertForPfbidUrls(newVal);
      this.alertForIgStoriesUrl(newVal);
    },
  },
  mounted() {
    // const $this = this;
    this.$nextTick(() => {
      // $this.initAutocomplete();
    });
  },
  methods: {
    handleDragOver() {
      this.isFileHovering = true;
    },
    handleDragLeave() {
      this.isFileHovering = false;
    },
    handleFileDrop(event) {
      this.isFileHovering = false;
      const file = event.dataTransfer.files[0];
      if (
        file &&
        (file.type === "text/csv" || file.type === "text/tab-separated-values")
      ) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.urls = e.target.result;
          this.addUrls();
        };
        reader.readAsText(file);
      }
    },
    initAutocomplete() {
      const $this = this;
      $(this.$refs.deliverables).search({
        showNoResults: false,
        // type: "category",
        // debug: true,
        // verbose: true,
        cache: false,
        maxResults: 5,
        minCharacters: 2,
        duration: 50,
        searchDelay: 25,
        searchOnFocus: false,
        //selectFirstResult: true,
        // onSearchQuery(query) {

        //   return lastLine;
        // },
        onSelect(result) {
          let urls = $this.urls.split("\n");
          urls[urls.length - 1] = result.url;

          $this.urls = urls.join("\n");
          $($this.$refs.deliverables).search("hide results");
          return false;
        },
        apiSettings: {
          url:
            "/deliverables/search.json?providers[]=facebook&providers[]=instagram&providers[]=twitter&providers[]=pinterest&providers[]=tik_tok&q[deliverable_search_query]={query}",
          beforeSend: function (settings) {
            let lines = settings.urlData.query.split("\n");
            var lastLine = lines[lines.length - 1];
            settings.urlData.query = lastLine;

            if (lastLine.length < 3) {
              return false;
            }
            return settings;
          },
        },
        fields: {
          results: "results",
          title: "text",
          description: "description",
          image: "picture",
          url: "_",
        },
      });
    },
    alertForPfbidUrls(newVal) {
      if (
        newVal.includes("pfbid") ||
        newVal.includes("www.facebook.com/share")
      ) {
        this.showModalAlert(
          `Facebook post URLs of this format can no longer be added via a link. Please use Quick Search to search for your deliverable.`,
          () => {
            // Hand off to Quick Search filtered to Facebook. Ask the parent to
            // set the search state directly (see index.vue) rather than
            // simulating checkbox clicks -- the old approach toggled every
            // provider checkbox, which fired a burst of synthetic clicks and,
            // because it toggled instead of assigning, landed on the wrong
            // providers on any repeat pass.
            this.$emit("requestQuickSearch", "facebook");
            this.urls = "";
          }
        );
      }
    },

    alertForIgStoriesUrl(newVal) {
      if (newVal.includes("instagram.com/stories")) {
        this.showModalAlert(
          `Instagram Stories can only be added from the Stories tab. If you're trying to add an expired Instagram Story, please follow <a href="https://help.influencekit.com/en/articles/5634991-how-to-add-expired-or-missing-instagram-stories-to-a-report" target="_blank">these steps</a>`,
          () => {
            // Hand off to the Stories tab and open its search form via parent
            // state (see index.vue) instead of blind-clicking DOM elements.
            this.$emit("requestStoriesSearch");
            this.urls = "";
          }
        );
      }
    },
    showModalAlert(content, action) {
      $("body")
        .modal({
          allowMultiple: true,
          class: "mini",
          closeIcon: false,
          content,
          actions: [
            {
              text: "Cancel",
              class: "deny",
            },
            {
              text: "Ok!",
              class: "primary approve",
            },
          ],
          onApprove() {
            if (action) {
              action();
            }
          },
        })
        .modal("show");
    },
    addUrls() {
      // Tapping Add with an empty box used to fire a no-op request with zero
      // feedback; say what's needed instead.
      if (!(this.urls || "").trim()) {
        this.errors = "Paste at least one URL or name first.";
        this.duplicates = null;
        return;
      }
      this.loading = true;
      this.errors = null;
      this.duplicates = null;

      const params = {
        deliverable_urls: this.urls,
      };
      if (this.$store && this.$store.state.report) {
        params.report_id = this.$store.state.report.id;
      }

      if (this.instagramReelsData) {
        params.instagram_reels_data = this.instagramReelsData;
        this.instagramReelsData = null;
      }

      this.submitUrls(params);
      this.urls = "";
    },
    // Split out of addUrls so a flagged paste can be resubmitted with
    // `confirmed: true` once the brand approves it, without retyping anything.
    submitUrls(params) {
      $.create(`${this.endpoint}/create_multiple.json`, params)
        .done((data) => {
          if (data.needs_confirmation) {
            this.loading = false;
            this.confirmMismatches(data, params);
            return;
          }
          this.$emit("create", data.saved);
          this.errors = data.errors;
          this.duplicates = data.duplicates;
          this.loading = false;
        })
        .fail((data) => {
          this.$emit("error", data.responseJSON.errors);
          this.errors = `Error: ${data.responseJSON.errors}`;
          this.loading = false;
        });
    },
    // This box is scoped to one creator's assignment. A pasted URL whose
    // handle doesn't match them is more likely a copy/paste mistake than
    // content this creator actually posted, so the server holds it back
    // (see AssignmentUrlMatchChecker) and this asks before adding it anyway.
    confirmMismatches(data, params) {
      const names = [...new Set(data.mismatches.map((m) => `@${m.handle}`))].join(", ");
      this.showModalAlert(
        `Some of these links look like they were posted by ${names}, not this creator. Add them anyway?`,
        () => {
          this.submitUrls({...params, confirmed: 1});
        }
      );
    },
  },
};
</script>

<style lang="css"></style>
<style scoped>
textarea.file-hover {
  border: 2px dashed var(--border-default) !important;
  background-color: var(--bg-surface-secondary) !important;
}

/* One Warm Light (deliverables sheet): the sticky Save Deliverables bar is
   the sheet's terminal action and its single solid coral. Add is mid-flow,
   so it waits as a quiet full-opacity coral tint -- the same tinted-chip
   grammar as Connect/View Report elsewhere in the app. Native only; web
   keeps its solid primary. */
html[data-hotwire-native] button.ui.button.primary {
  background: rgba(244, 128, 111, 0.15) !important;
  color: var(--color-primary-hover, #e06b5a) !important;
}

html[data-hotwire-native] button.ui.button.primary:hover,
html[data-hotwire-native] button.ui.button.primary:focus,
html[data-hotwire-native] button.ui.button.primary:active {
  background: rgba(244, 128, 111, 0.24) !important;
  color: var(--color-primary-hover, #e06b5a) !important;
}
</style>
